import skill_1 from '../images/skill_1.svg'
import skill_2 from '../images/skill_2.svg'
import skill_3 from '../images/skill_3.svg'
import skill_4 from '../images/skill_4.svg'
import skill_5 from '../images/skill_5.svg'
import skill_6 from '../images/skill_6.svg'

// About page
const AboutMe =
  'With the background of Economics and Data Science, I am a data scientist dedicated to solving realistic business problems:'
const BusinessProblem = [
  'Delivering merchandising insights',
  'Modeling and analysis of consumer behavior',
  'Discovering new market trends',
  'Optimizing product iteration process',
  'Campaign evaluation & recommendation',
  'Reducing fraud',
  'Building business metrics',
  'Business data management',
]

const SkillData = [
  {
    img: [skill_1],
    title: 'Related Courses',
    content: [
      'Natural Language Processing',
      'Python Programming',
      'Advanced Data Visualization',
      'Digital Storytelling',
    ],
  },
  {
    img: [skill_2],
    title: 'Data Analysis',
    content: ['Python', 'R programming', 'SPSS', 'Stata', 'AWS', 'Tensorflow'],
  },
  {
    img: [skill_3],
    title: 'Data Visualization & Management',
    content: ['Tableau', 'R shiny', 'MySQL', 'Hadoop'],
  },
  {
    img: [skill_4],
    title: 'Machine Learning',
    content: [
      'Linear regression',
      'Clustering',
      'Decision Trees',
      'Naive Bayes',
      'Neural Networking',
      'Deep learning',
    ],
  },
  {
    img: [skill_5],
    title: 'Business Sense',
    content: [
      'Customer Analysis',
      'Product Analysis',
      'Market Analysis',
      'Risk Analysis',
    ],
  },
  {
    img: [skill_6],
    title: 'Soft Skills',
    content: ['Curiosity', 'Multi-task Taker', 'Storyteller', 'Leadership'],
  },
]

export const AboutData = {
  aboutMe: AboutMe,
  businessProblem: BusinessProblem,
  skillData: SkillData,
}
